<template>
	<div v-show="show">
		<div class="vx-card p-6">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					<!-- ADD NEW -->
					<div
						v-if="roleCreatePermission"
						class="btn-add-new p-3 mb-3 mt-3 ml-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
						@click="addNewData"
					>
						<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
						<span class="ml-2 text-base text-primary pr-2">{{ $t(`MODULE_ROLE.Add`) }}</span>
					</div>
				</div>
			</div>
			<RoleList v-if="roleReadPermission" />

			<not-permission v-else></not-permission>
		</div>
	</div>
</template>

<script>
// Components
import RoleList from "@/components/role/RoleList.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		RoleList,
		NotPermission,
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		roleCreatePermission() {
			return this.$store.getters.checkPermission("ROLE_C");
		},
		roleReadPermission() {
			return this.$store.getters.checkPermission("ROLE_R");
		},
	},
	methods: {
		addNewData() {
			this.$router.push({name: "CreateRole"});
		},
	},
	created() {},
	mounted() {
		this.show = true;
	},
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
